<script>
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$route} = useTools();

        const paySlipAnnex = ref({
            details: [],
            parameters: [],
            totals: [],
        });

        function findById(id) {
            axios.get(`/paySlipAnnexes/findByIdWithDetails/${id}`).then(response => {
                paySlipAnnex.value = response.data;
            });
        }

        const documentUrl = ref(null);

        function print() {
            loading.value = true;
            documentUrl.value = null;
            axios.get(`/printed/getEtatRecapitulatif`, {
                responseType: 'blob',
                params: {
                    annexId: $route.params.id
                }
            }).then(response => {
                const blob = response.data;
                documentUrl.value = window.URL.createObjectURL(blob);
            }).finally(() => {
                loading.value = false;
            })
        }

        onMounted(() => {
            findById($route.params.id);
            print();
        });

        return {
            dialog,
            loading,
            paySlipAnnex,
            documentUrl,
            getBack
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="1000"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="paySlipAnnex.name "/>
            <v-card-text>
                <v-container fluid>
                    <iframe
                        v-if="documentUrl"
                        :src="documentUrl"
                        width="100%"
                        height="600px"
                    />
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack" :loading="loading"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>